// @core/api/endpoints/task/delete_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete template
 * Deletes a task template. Tasks created from this template are not affected.
 */
export async function DeleteTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
